<template>
  <div id="chatbox" ref="chatbox" v-resize="onResizeChatbox" :style="{ height: chatboxHeight }">
    <!-- :style="{ height: chatboxHeight, 'overflow-y': isMobile ? 'hidden' : 'auto' }"
    @scroll="onMessageScroll"
    class="custom-scroll" -->
    <!-- <div v-html="debug" style="position:absolute; color:red;z-index: 10;background: white"></div> -->
    <template v-if="selectedUser">
      <!-- แถบชื่อและช่องค้นหาข้อความ -->
      <div
        dark
        flat
        style="top: 0; background: white !important; display: flex; flex-direction: column; justify-content: center;"
        :style="{ top: isMobile ? '56px' : '0px', height: toolbarHeight }"
        class="underLine"
      >
        <!-- border-bottom: 1px solid #BDBDBD !important;  -->
        <!--  border-bottom: 1px solid #BDBDBD; -->
        <!-- , 'border-bottom': '1px solid #BDBDBD;' -->

        <!-- <v-btn
          flat
          dark
          fab
          small
          class="ma-0 btn-back extra-small"
          @click="$emit('onClose')"
          v-show="isMobile"
        >
          <v-icon medium>keyboard_arrow_left</v-icon>
        </v-btn> -->

        <!-- กล่องค้นหา -->
        <div
          style="margin-left: 20px; color: #0C2F53; font-weight: 700; position: relative; font-size: 22px; display: flex; flex-direction: row;"
        >
          <input
            type="text"
            v-model="searchText"
            id="search-box"
            placeholder="ค้นหา"
            prepend-icon="mdi-magnify"
            @keydown.enter="highlightText()"
            style="padding: 12px 20px; margin: 8px 0; box-sizing: border-box; box-shadow: none;
                  width: 338px; height: 38px; border: 1px solid #0C2F53; border-radius: 20px;
                  position: relative; z-index: 1; padding-right: 60px;"
          />

          <v-icon
            depressed
            style="border-radius: 0; width: 24px; position: relative; height: 100%; display: flex; flex-direction: column;
                  justify-content: center; align-items: center; cursor: pointer;  
                  position: relative; z-index: 2; left: -40px;"
            color="#BDBDBD"
            @click="highlightText()"
            >search</v-icon
          >

          <div style="display: flex; flex-direction: column;">
            <v-icon
              depressed
              style="border-radius: 0; width: 24px; height: 100%; display: flex;
                  justify-content: center; align-items: end; cursor: pointer; position: relative; left:-22.5px; z-index: 2;"
              color="#BDBDBD"
              @click="scrolluptoSearchText()"
              >mdi-chevron-up</v-icon
            >
            <v-icon
              depressed
              style="border-radius: 0; width: 24px; height: 100%; display: flex;
                  justify-content: center; align-items: start; cursor: pointer; position: relative; left:-22.5px; z-index: 2;"
              color="#BDBDBD"
              @click="scrolldowntoSearchText()"
              >mdi-chevron-down</v-icon
            >
          </div>
          <div
            style="border-radius: 0; width: 24px; height: 100%; display: flex;
                  justify-content: center; align-items: center; position: relative; left:-20px; z-index: 0;
                  font-size: 14px !important; color: #BDBDBD;" 
          >
            {{ searchTextIndex }}{{ '/' }}{{ allTextNumber }}
          </div>
        </div>

        <v-toolbar-title style="color: #0C2F53; font-weight: 700; font-size: 22px; ">
          {{ selectedUser.first_name }} {{ selectedUser.last_name }}
        </v-toolbar-title>

        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn
          flat
          dark
          fab
          small
          class="ma-0 btn-back"
          @click="$emit('onShowTool')"
          v-show="isMobile"
        >
          <v-icon medium>settings_applications</v-icon>
        </v-btn> -->

        <!-- <div v-show="!isMobile"> -->
        <!-- กลับไปเป็นแชทบอท -->
        <!-- <v-btn
            color="primary"
            small
            outline
            @click="endSession"
            v-if="selectedUser.context == 'contactadmin'"
            style="line-height: 0"
            >{{ $t('Switch to bot') }}</v-btn
          > -->
        <!-- กลับไปเป็นแอดมิน -->
        <!-- <v-btn
            color="primary"
            small
            outline
            @click="openSession"
            v-else-if="selectedUser.context != 'contactadmin'"
            style="line-height: 0"
            >{{ $t('Switch to admin') }}</v-btn
          > -->
        <!-- </div> -->
      </div>

      <!-- ช่องแชท -->
      <div
        id="chatbox-container"
        style="
          position: relative;
          padding-top: 5px; 
          padding-bottom: 5px;
          "
        :style="{
          'margin-bottom': chatinputHeight + 'px',
          'margin-top': isMobile ? '56px' : '0px'
        }"
      >
        <!-- 
          top: isMobile ? '0px' : '64px', -->
        <!-- 'padding-bottom': chatinputHeight + 'px', -->
        <!-- border-top: 1px solid red;
          border-bottom: 1px solid blue; -->
        <template v-if="messages.length > 0">
          <!-- :style="{'height': '483px'}" -->
          <div
            id="messages"
            class="custom-scroll"
            @scroll="onMessageScroll"
            style="overflow-y: scroll;"
            :style="{ height: messageboxHeight }"
          >
            <!-- :style="{ height: '483px'}" -->
            <!-- <template v-if="isMobile">
              <div
                class="text-xs-center"
                style="background: #eee; padding-top: 10px; padding-bottom: 10px"
                @click="onLoadmore"
              >
                <template v-if="loadmore">
                  <v-progress-circular
                    indeterminate
                    color="grey"
                    small
                    class="mr-2"
                    :width="2"
                  ></v-progress-circular
                  >Loading
                </template>
                <template v-else @click="onLoadmore">Click to load more conversation</template>
              </div>
            </template>
            <template v-else> -->
            <template>
              <div
                v-if="loadmore"
                class="text-xs-center"
                style="background: #eee; padding-top: 10px; padding-bottom: 10px"
              >
                <v-progress-circular
                  indeterminate
                  color="grey"
                  small
                  class="mr-2"
                  :width="2"
                ></v-progress-circular
                >Loading
              </div>
            </template>
            <template v-for="(message, index) in messages">
              <!-- {{ message}} {{ index }} -->
              <!-- {{ index }} -->
              <!-- แสดงวันที่ -->
              <div
                :key="index"
                style="display: flex; justify-content: center;"
                v-if="eachDay.find(message => message.index === index)"
              >
                <!-- class="d-flex  justify-center py-2" -->
                <span class="fs12 lightMediumGrey px-1  bg-lightGrey radius-5">
                  {{ dateFormat(message.timestamp) }}
                </span>
              </div>
              <message-item
                :id="`message_${message.id}`"
                v-if="messages"
                :key="'message-' + message.id + message.userid + message.pageid"
                v-model="messages[index]"
                :receiver="selectedUser"
              ></message-item>
            </template>
          </div>
        </template>
        <template v-else>
          <v-layout column justify-center>
            <div class="text-xs-center mt-5" style="color: #eee">
              <img src="/static/img/assets/livechat/no_message.png" alt />
              <p>No message</p>
            </div>
          </v-layout>
        </template>
      </div>

      <!-- ช่องส่งข้อความ -->
      <chat-input
        id="chatinput"
        v-model="selectedUser"
        :app="selectedUser.app"
        @onSendMessage="onSendMessage($event)"
        class="overLine"
      >
        <div v-if="!isAutoRefresh" slot="header" style="display: flex; justify-content:center;">
          <v-btn
            style="top: -45%; position: absolute; z-index: 3; border-radius: 20px !important; font-family:'Sukhumvit' !important;"
            color="primary"
            @click="gotobottom"
            depressed
          >
            <v-icon>keyboard_arrow_down</v-icon>Go to bottom
          </v-btn>
        </div>
      </chat-input>
    </template>
    <template v-else>
      <v-layout column justify-center fill-height>
        <div class="text-xs-center" style="color: #eee">
          <img src="/static/img/assets/livechat/no_user.png" alt />
          <p>Select a user</p>
        </div>
      </v-layout>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import messageItem from './livechat-message'
import chatInput from './livechat-chatinput'
import api from '@/api'
import Typography from '@/components/elements/Typography.vue'
import moment from 'moment'
import * as dayjs from 'dayjs'
let buddhistEra = require('dayjs/plugin/buddhistEra')
dayjs.extend(buddhistEra)
require('dayjs/locale/th')

export default {
  props: ['value', 'isMobile'],
  components: {
    Typography
  },
  data: function() {
    return {
      eachDay: [],

      loadmore: false,

      chatboxHeight: 0,
      messageboxHeight: 0,
      loading: false,
      maxTime: 10000,
      timer: '',
      isAutoRefresh: true,
      currentIndex: null,

      offset: 0,
      limit: 100,
      messages: [],

      // oldMessages: [],
      endChatlog: false,

      windowHeight: 0,

      newMessage: null,
      chatinputHeight: 0,
      debug: '',

      searchText: '',
      oldSearchText: '',
      scrollToText: 0,
      scrollToTextArray: [],
      searchTextIndex: 0,
      allTextNumber: 0,
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      selectedUser: 'getCurrentUser'
    })
  },
  components: {
    'message-item': messageItem,
    'chat-input': chatInput
  },
  created: async function() {
    let vm = this
    this.resetChatlog()
    await this.getLastedMessages()
    await this.wait(1000)
    // if (vm.isMobile) {
    //   document.body.onscroll = function () {
    //     vm.onMessageScroll()
    //   }
    // }
  },
  mounted: function() {
    // console.log("message-box", this)
    let vm = this
    if (!this.timer) this.timer = setInterval(this.getLastedMessages, this.maxTime)
  },
  async updated() {
    this.snapBottom()
  },
  methods: {
    hilightIndex(index) {
      // console.log(index)
      this.searchTextIndex = this.scrollToTextArray.indexOf(this.scrollToText) + 1
      return 
    },
    // กล่องค้นหา
    highlightText() {
      // console.log(document.getElementById("search-box").value)
      
      const messageTexts = document.querySelectorAll('[id="messageText"]')
      const searchText = document.getElementById('search-box').value
      // console.log(searchText)
      if (searchText == '')  {
        for (let i = 0; i < messageTexts.length; i++) {
          // console.log(messageTexts[i].innerHTML)

          // รับค่า div element ที่ต้องการ highlight
          const div = messageTexts[i]
          // แปลง innerHTML เป็น string
          const html = div.innerHTML
          // ใช้ replace() และ RegExp เพื่อค้นหาคำที่ต้องการ highlight และเพิ่ม tag <mark> เข้าไป
          const newHtml = html.replace(/<mark>/g, '').replace(/<\/mark>/g, '')
          // กำหนด innerHTML ของ div ให้เป็น newHtml
          div.innerHTML = newHtml
        }
        this.searchTextIndex = 0;
        this.allTextNumber = 0;
      }

      else if (this.oldSearchText != searchText) {
        this.scrollToTextArray.length = 0
        //console.log(messageTexts)
        for (let i = 0; i < messageTexts.length; i++) {
          // console.log(messageTexts[i].innerHTML)

          // รับค่า div element ที่ต้องการ highlight
          const div = messageTexts[i]
          // แปลง innerHTML เป็น string
          const html = div.innerHTML
          // ใช้ replace() และ RegExp เพื่อค้นหาคำที่ต้องการ highlight และเพิ่ม tag <mark> เข้าไป
          const newHtml = html.replace(/<mark>/g, '').replace(/<\/mark>/g, '')
          // กำหนด innerHTML ของ div ให้เป็น newHtml
          div.innerHTML = newHtml
        }
        for (let i = 0; i < messageTexts.length; i++) {
          // console.log(messageTexts[i].innerHTML)

          // รับค่า div element ที่ต้องการ highlight
          const div = messageTexts[i]
          // แปลง innerHTML เป็น string
          const html = div.innerHTML
          if (html.includes(searchText)) this.scrollToTextArray.push(i)
          // ใช้ replace() และ RegExp เพื่อค้นหาคำที่ต้องการ highlight และเพิ่ม tag <mark> เข้าไป
          const newHtml = html.replace(new RegExp(searchText, 'g'), `<mark>${searchText}</mark>`)
          // กำหนด innerHTML ของ div ให้เป็น newHtml
          div.innerHTML = newHtml
        }
        this.oldSearchText = searchText

        this.scrollToText = this.scrollToTextArray[this.scrollToTextArray.length - 1]
        this.searchTextIndex = this.scrollToTextArray.indexOf(this.scrollToText) + 1
        this.allTextNumber = this.scrollToTextArray.length
        // console.log(this.scrollToText)
        // console.log(this.scrollToTextArray.indexOf(this.scrollToText))
        // messageTexts[this.scrollToText].innerHTML = messageTexts[this.scrollToText].innerHTML.replace(/<mark>/g, '<mark class="mark-custom">')
        messageTexts[this.scrollToText].scrollIntoView()
        //console.log(this.scrollToText)
        // this.scrolluptoSearchText()
      }
      // else {
      //   this.scrolluptoSearchText()
      // }
    },
    scrolluptoSearchText() {
      const messageTexts = document.querySelectorAll('[id="messageText"]')
      // if(this.scrollToTextArray.indexOf(this.scrollToText) <= 0) this.scrollToText = this.scrollToTextArray[this.scrollToTextArray.length - 1]
      const searchText = document.getElementById('search-box').value
      if (searchText == '')  {
        
      }
      else {
      if (this.scrollToTextArray.indexOf(this.scrollToText) > 0) {
        // messageTexts[this.scrollToText].innerHTML.replace(/class="highlight-2"/g, 'class="highlight-1"')
        this.scrollToText = this.scrollToTextArray[
          this.scrollToTextArray.indexOf(this.scrollToText) - 1
        ]
      }
      this.searchTextIndex = this.scrollToTextArray.indexOf(this.scrollToText) + 1
      messageTexts[this.scrollToText].scrollIntoView()
      }
    },
    scrolldowntoSearchText() {
      const messageTexts = document.querySelectorAll('[id="messageText"]')
      // if(this.scrollToTextArray.indexOf(this.scrollToText) >= this.scrollToTextArray.length - 1) this.scrollToText = this.scrollToTextArray[0]
      const searchText = document.getElementById('search-box').value
      if (searchText == '')  {
        
      }
      else {
      if (this.scrollToTextArray.indexOf(this.scrollToText) < this.scrollToTextArray.length - 1) {
        // messageTexts[this.scrollToText].innerHTML = messageTexts[this.scrollToText].innerHTML.replace(/<mark class="mark-custom">/g, '<mark>')
        this.scrollToText = this.scrollToTextArray[
          this.scrollToTextArray.indexOf(this.scrollToText) + 1
        ]
      }

      this.searchTextIndex = this.scrollToTextArray.indexOf(this.scrollToText) + 1
      messageTexts[this.scrollToText].scrollIntoView()
    }
    },
    async gotobottom() {
      await this.$nextTick()
      // console.log(this.scrollToText)
      const messages = document.getElementById('messages')
      if (messages) {
        messages.scrollTop = messages.scrollHeight
      }
    },
    // onSearchMessage(searchMessage){
    //   console.log(this.messages)
    // },
    replaceDate(data) {
      //ใช้เก็บเเยกวันที่
      // console.log("replaceDate", data)
      const filteredArray = Array.from(
        data
          .reduce((map, item, index) => {
            // console.log(dayjs(item.timestamp).format("YYYY-MM-DD"));

            const date = dayjs(item.timestamp).format('YYYY-MM-DD')
            // console.log(date)
            const time = dayjs(item.timestamp).format('HH:mm:ss.SSS')
            // console.log(time)
            const existing = map.get(date)
            // console.log(existing)
            if (!existing || time < dayjs(existing.timestamp).format('HH:mm:ss.SSS')) {
              map.set(date, { timestamp: item.timestamp, index })
            }
            return map
          }, new Map())
          .values()
      )
      this.eachDay = filteredArray
      // console.log(this.eachDay)
      //
    },
    dateFormat(date) {
      // console.log()
      return dayjs(date)
        .locale('th')
        .format('DD MMM BB')
    },
    onResizeChatbox: function() {
      var vm = this
      vm.$nextTick(function() {
        // if (this.isMobile) {
        //   vm.chatboxHeight = 'auto'
        //   // vm.chatinputHeight = 0
        // } else {
        vm.chatboxHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - 40 + 'px'
        // }
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight + 'px'
        }
        vm.toolbarHeight = document.getElementById('main_toolbar').clientHeight + 40 + `px`
        vm.messageboxHeight =
          window.innerHeight -
          document.getElementById('main_toolbar').clientHeight -
          40 -
          document.getElementById('chatinput').clientHeight -
          document.getElementById('main_toolbar').clientHeight -
          40 -
          5 -
          5 +
          `px`
        vm.debug =
          `Chatbox Height: ${vm.chatboxHeight}<br>` +
          `Input Height: ${vm.chatinputHeight}<br>` +
          `Screen Height: ${screen.height}<br>` +
          `Main Toolbar: ${document.getElementById('main_toolbar').clientHeight}<br>` +
          `Window: ${window.innerHeight}<br>`
      })
    },
    async onSendMessage(payload) {
      this.messages.push(payload)
      await this.snapBottom()
      // console.log(payload)
    },
    getLastedMessages: async function() {
      var vm = this
      let limit = 15

      if (vm.messages.length == 0) {
        limit = 100
      }
      if (!vm.selectedUser) {
        return false
      }
      try {
        await vm.getUserMessages(0, limit, true)

        vm.onResizeChatbox()
        if (vm.isAutoRefresh && document.getElementById('messages')) {
          // $('#chatbox').animate({ scrollTop: document.getElementById('messages').clientHeight })
          await vm.snapBottom()
        }
        vm.replaceDate(this.messages)
      } catch (error) {}
      //console.log('loaded', this.selectedUser.userid)

      // console.log(this.messages)
    },
    getUserMessages: function(offset, limit, latest) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (vm.selectedBot == null || vm.selectedUser == null || vm.loading || !vm.isAutoRefresh) {
          reject()
          // return false
        }
        vm.loading = true
        let data = {
          pageid: vm.$store.state.livechat.pageid,
          userid: vm.selectedUser.userid,
          offset: offset,
          limit: limit,
          adminid: vm.$store.state.userid
        }
        if (!latest) {
          vm.loadmore = true
        }
        let auth = null
        api.getUserMessages(data, function(error, response) {
          if (error) {
            if (!latest) {
              vm.loadmore = false
            }
            reject(error)
          }
          if (response.data) {
            if (!latest && response.data.length == 0) {
              vm.endChatlog = true
            }
            if (latest) {
              if (vm.messages.length == 0) {
                var messages = response.data.reverse()
                vm.messages = []
                messages.map(function(el) {
                  vm.messages.push(el)
                })
                vm.$nextTick(function() {
                  if (vm.isAutoRefresh) {
                    vm.snapBottom()
                  }
                })
              } else {
                if (
                  response.data &&
                  response.data[0] &&
                  vm.currentIndex &&
                  response.data[0].id == vm.currentIndex.id
                ) {
                  // console.log('Noting Change')
                  vm.loading = false
                  resolve()
                } else {
                  vm.messages = vm.messages.splice(0, vm.currentIndex.index)
                  let tmpIndex = response.data.findIndex(val => {
                    return val.id == vm.currentIndex.id
                  })

                  if (tmpIndex != -1) {
                    for (var i = tmpIndex; i >= 0; i--) {
                      vm.messages.push(response.data[i])
                    }

                    if (response.data[0]) {
                      vm.newMessage = response.data[0]
                    }

                    vm.snapBottom()
                  }
                  resolve()
                }
              }
            } else {
              vm.messages = response.data.reverse()
              vm.loadmore = false
            }
            if (vm.messages.length > 0) {
              vm.currentIndex = {
                id: vm.messages[vm.messages.length - 1].id,
                index: vm.messages.length - 1
              }
            }
            vm.loading = false
          }
          resolve()
        })
      })
    },
    // enableAutoUpdate: function() {
    //   this.isAutoRefresh = !this.isAutoRefresh
    //   if (this.isAutoRefresh) {
    //     this.timer = setInterval(this.getSummary, this.maxTime)
    //   } else {
    //     clearInterval(this.timer)
    //   }
    // },
    onMessageScroll: function() {
      //let scrollPosition = 0
      // if (this.isMobile) {
      //   scrollPosition = window.pageYOffset + window.innerHeight
      //   let totalHeight = document.body.scrollHeight
      //   // console.log(totalHeight == scrollPosition)
      //   if (totalHeight == scrollPosition) {
      //     this.isAutoRefresh = true
      //   } else {
      //     this.isAutoRefresh = false
      //   }
      //   // console.log(scrollPosition, totalHeight)
      //   return false
      // } else {
      let messages = document.getElementById('messages')
      //scrollPosition = messages.scrollTop
      let chatboxHeight = messages.clientHeight
      let totalHeight = messages.scrollHeight

      //console.log("console.log ", totalHeight, messages.scrollTop, chatboxHeight, messages)
      if (totalHeight - 30 <= messages.scrollTop + chatboxHeight) {
        this.isAutoRefresh = true
      } else {
        this.isAutoRefresh = false
      }
      // }

      if (messages.scrollTop == 0) {
        this.onLoadmore().then(function() {})
      }
    },
    onLoadmore: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        if (vm.loadmore) {
          reject()
        }
        vm.limit += 100
        vm.getUserMessages(vm.offset, vm.limit, false).then(
          function() {
            // $('#chatbox').animate({ scrollTop: 0 })
            resolve()
          },
          function() {}
        )
      })
    },
    async snapBottom() {
      let vm = this
      if (!vm.isAutoRefresh || vm.loadmore) {
        return false
      }
      const searchText = document.getElementById('search-box').value
      if (searchText == '') await vm.gotobottom()
      // await vm.gotobottom()
    },
    // async gotobottom() {
    //   await this.$nextTick()
    //   let messages = $('#messages')
    //   if (messages.length > 0) {
    //     // if (this.isMobile) {
    //     //   window.scrollTo(
    //     //     0,
    //     //     document.body.scrollHeight +
    //     //       (this.chatinputHeight == 0 ? 114 : this.chatinputHeight * 2)
    //     //   )
    //     // } else {
    //       document
    //         .getElementById('chatbox')
    //         .scrollTo(0, document.getElementById('messages').clientHeight)
    //     // }
    //   }
    // },

    resetChatlog: function() {
      this.messages = []
      this.offset = 0
      this.limit = 100
      this.endChatlog = false
      this.loading = false
      this.loadmore = false
      this.isAutoRefresh = true
      this.newMessage = null
    },
    endSession: function() {
      this.$emit('endSession')
    },
    openSession: function() {
      this.$emit('openSession')
    }
  },
  watch: {
    selectedUser: function(newVal, oldVal) {
      // this.selectedUser = newVal
      if (newVal == null || oldVal == null || oldVal != newVal) {
        this.resetChatlog()
        this.getLastedMessages()
      }
    },
    selectedBot: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectedUser = null
        this.resetChatlog()
      }
    }
  },
  beforeDestroy: function() {
    //console.log('clear')
    clearInterval(this.timer)
    document.removeEventListener('scroll', null, false)
  }
}
</script>

<style lang="scss" scoped>
body {
  font-family: 'Sukhumvit Set' !important;
}

.underLine {
  position: relative;
}

.underLine::before {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 5%;
  width: 90%;
  height: 1px;
  background-color: rgba(189, 189, 189, 1);
}
.overLine {
  position: relative;
}
.overLine::before {
  content: '';
  position: absolute;
  top: -1px;
  left: 5%;
  width: 90%;
  height: 1px;
  background-color: rgba(189, 189, 189, 1);
}
.btn-back i {
  line-height: 0;
}

.custom-scroll::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.custom-scroll::-webkit-scrollbar-track {
  background-color: rgba(255, 255, 255, 1);
}

.custom-scroll::-webkit-scrollbar-thumb {
  background-color: #0c2f53;
  border-radius: 20px;
}
.mark {
  background-color: yellow;
}

.mark-custom {
  background-color: blue;
}
.v-text-field__slot input {
  outline: none; /* ปิดเส้นขอบ */
  box-shadow: none; /* ปิดเงา */
  border-color: transparent; /* ปิดเส้นขอบ */
  text-decoration: none !important;
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chatbox.vue